import React from 'react';

function Error() {
    return (
        <div className="container">
            <h1>404</h1>
            <div className="text-center">
                <img src="/img/404-tsadkiel_chara_design-1024x967.webp" alt="Error" style={{ maxWidth: "90vw", maxHeight: "70vh", height: "auto" }} />
            </div>
            <p>Trouvez moi!</p>
        </div>
    );
}

export default Error;